import { render } from "./ClauseItem.vue?vue&type=template&id=d5bd0b94&scoped=true"
import script from "./ClauseItem.vue?vue&type=script&lang=js"
export * from "./ClauseItem.vue?vue&type=script&lang=js"

import "./ClauseItem.vue?vue&type=style&index=0&id=d5bd0b94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5bd0b94"],['__file',"src/components/offersDetails/ClauseItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5bd0b94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5bd0b94', __exports__)) {
    api.reload('d5bd0b94', __exports__)
  }
  
  module.hot.accept("./ClauseItem.vue?vue&type=template&id=d5bd0b94&scoped=true", () => {
    api.rerender('d5bd0b94', render)
  })

}


export default __exports__